import React from "react";
import {
  makeStyles,
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  CardActions,
  useTheme,
  Typography,
  Button,
  Box,
  Grid,
  Container,
  Divider,
  useMediaQuery
} from "@material-ui/core";
import Pagination from '@material-ui/lab/Pagination';

export default function TextBooks() {
  return (
    <Box>
      <Title />
      <CardLists />
    </Box>
  );
}

function Title() {
  const theme = useTheme();
  const isPhone = useMediaQuery("(max-width:600px)")
  return (
    <Box py={6}>
      <Container maxWidth="md">
        <Typography
          variant={isPhone? "h6":"h5"}
          align="center"
          style={{ color: theme.palette.secondary.light }}
        >
          富屋房屋/法拍屋 - 商品價目表
          <br />
          (全省法院均一價)
        </Typography>
      </Container>
    </Box>
  );
}

function CardLists() {
  const theme = useTheme();
  const isPhone = useMediaQuery("(max-width:600px)")
  const useStyles = makeStyles((theme) => ({
    cardHeader: {
      backgroundColor: theme.palette.secondary.light,
      color: "#fff",
      textAlign: "center",
      padding: "8px 0",
      "& .MuiCardHeader-title":{
        fontSize:'1.5rem',
      },
    },
    media: {
      height: 0,
      paddingTop: "56.25%", // 16:9
      backgroundSize: "contain",
      padding: "2em 0",
      margin: "1em 0",
    },
    cardContent:{
      height:'120px',
      display:'flex',
      alignItems:'center',
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      "-webkit-line-clamp": 4,
      "-webkit-box-orient": "vertical",
    },
  }));
  const classes = useStyles();

  const productList = [
    {
      title: "九轉神功",
      image: "/assets/images/TextBooks/100kTobillion.jfif",
      content:
        "法拍不動產客戶問答Q&A，集結數十年經驗與功力，讓你從事法拍不動產業務事業時能更精準有效率的掌握各項專業技巧，事事無往不利。",
      price: "3000",
    },
  ];

  return (
    <Box>
      <Container maxWidth="md">
        <Grid container spacing={4}>
          {productList.map((item) => {
            return (
              <Grid item xs={12} md={6}>
                <Card className={classes.card}>
                  <CardHeader
                    title={item.title}
                    className={classes.cardHeader}
                  />
                  <CardMedia
                    className={classes.media}
                    image={item.image}
                    title={item.title}
                  />
                  <CardContent className={classes.cardContent} >
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      component="p"
                    >
                      {item.content}
                    </Typography>
                  </CardContent>
                  <Box style={{ padding: "16px" }}>
                    <Divider
                      style={{ backgroundColor: theme.palette.secondary.light }}
                    />
                  </Box>
                  <CardActions
                    style={{ justifyContent: "space-between", padding: "16px" }}
                  >
                    <Typography variant={isPhone ? "h5":"h4"} style={{color:theme.palette.secondary.light,fontWeight:'bold'}}>
                      ${item.price}
                    </Typography>
                    <Button
                      color="primary"
                      variant="contained"
                      style={{ width:isPhone ?  "120px":"150px" }}
                      size={isPhone ? "":"large"}
                    >
                      線上購買
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>

        <Box>
          <PaginationList/>
        </Box>
      </Container>
    </Box>
  );
}


// pagination


function PaginationList() {
  const theme = useTheme();
  const useStyles = makeStyles((theme) => ({
    pagiBox: {
      marginTop:"4em",
      display:'flex',
      justifyContent:'center',
      "& .MuiPaginationItem-textSecondary.Mui-selected":{
        backgroundColor:theme.palette.secondary.light,
      },
    },
  }));
  const classes = useStyles();
  const [page, setPage] = React.useState(1);
  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <div className={classes.pagiBox}>
      <Pagination count={1} page={page} onChange={handleChange} color="secondary"  />
    </div>
  );
}
